// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
Vue.use(BootstrapVue)

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC5BNrRl02UO6sCcXMHzd-EIaLfnfWBEio'
  }
})

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-87579118-1',
  router
})

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  //document.title = to.meta.title
  next()
})

Vue.mixin({
  mounted(){
    window.scrollTo({top: 0, left: 0})
    //window.scrollTo({top: 0, left: 0,  behavior: 'smooth'})
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js